var searchInput = document.querySelector('#article-search-input');
var results_element = document.querySelector('.article-search__results-list');
var filter_buttons = document.querySelector('.article-search__filters');
var form = document.querySelector('.article-search__form');

// Tempaltes defined in .liquid
// var no_results_template = {{ no_results_template | json }};
// var results_template = {{ results_template | json }};

var active_filters = [];
var stored_results;
var urlParams = new URLSearchParams(window.location.search);
var query = urlParams.get('query');

let timeout = null;




// If search element and no existing search query, add predictive search API to search input
if(searchInput && !query) {
    // Listen for keystroke events
    searchInput.addEventListener('keyup', function (e) {
        // Clear the timeout if it has already been set.
        // This will prevent the previous task from executing
        // if it has been less than <MILLISECONDS>
        clearTimeout(timeout);
        // Make a new timeout set to go off in 1000ms (1 second)
        timeout = setTimeout(function () {
            predictiveSearchFetch(searchInput.value, active_filters)
        }, 1000);
    });
}

// If existing query detected, render it as a search results page
if(query) {
    searchInput.value = query;
    searchFetch(query);
}

// Add event listeners to the filter buttons
if(filter_buttons) {
    filter_buttons.addEventListener('click', function(event) {
        if(event.target.type == 'checkbox') {
            var checkbox = event.target;
            var filter = checkbox.getAttribute('data-tag-filter');
            if(checkbox.checked) {           
                active_filters.push(filter);

                if (stored_results) {
                    renderSearchResults(stored_results, active_filters);
                }
            } else {
                active_filters = active_filters.filter(active_filter => {
                    return active_filter !== filter;
                });

                if (stored_results) {
                    renderSearchResults(stored_results, active_filters);
                }
            }
        }
    });
}

// Fetch results from templates/search.articles.liquid
function searchFetch(query) {
    fetch(`/search?q=${query}&type=article&view=articles`)
    .then((response) => {
        return response.text();
    }).then( response => {
        const html = document.createElement("div");
        html.innerHTML = response;
        const articlesJSON = JSON.parse(
            html.querySelector("[data-json-response]").innerHTML
        );

        stored_results = articlesJSON;
        document.querySelector("#filter-text").innerHTML = query;
        renderSearchResults(articlesJSON, active_filters);
    });
}

function predictiveSearchFetch(query, filter) {
    fetch(`/search/suggest.json?q=${query}&resources[type]=article&resources[options][fields]=author,title,tag`)
    .then((response) => response.json())
    .then((suggestions) => {
        var articles = suggestions.resources.results.articles;
        document.querySelector("#filter-text").innerHTML = query;
        renderSearchResults(articles, filter)
    });
}

// Replace the placeholders in the template with the real values
// Add more placeholders to results_template in sections/article-search.liquid if more are needed
// article = Shopify Article object
function buildResult(article) {
    var item = results_template;
    item = results_template;
    item = item.replace(/{url}/g, article.url);
    item = item.replace(/{title}/g, article.title);
    item = item.replace(/{summary_html}/g, article.summary_html);
    item = item.replace(/{tags}/g, article.tags);
    return item;
}



function renderSearchResults(articles, active_filters) {
    results_element.innerHTML = '';
    var html = '';

    stored_results = articles;

    if (articles.length > 0) {
        var new_articles = articles;
        active_filters.forEach(active_filter => {
            new_articles = new_articles.filter(suggestion => {
                if (suggestion.tags.includes(active_filter)) { 
                    return suggestion;
                }
            });
        });

        new_articles.forEach(new_article => {  
            html += buildResult(new_article);
        });

        filter_buttons.style.display = 'block';

        results_element.innerHTML = html;

        document.querySelector("#filter-text-label").style.display= "block";
        document.querySelector("#suggestions-text").style.display= "none";
    } else {

        filter_buttons.style.display = 'none';
        
        results_element.innerHTML = no_results_template;
    }
}
